/**
 * MCP (Model Context Protocol) admin/review surfaces:
 *  - draft clinical notes an MCP agent proposed, that a human already confirmed
 *  - the MCP tool-invocation audit trail (super-admin visibility)
 *  - a clinic's own write-tools opt-in toggle
 *
 * Backend paths are under server.servlet.context-path=/api + the controller's own mapping —
 * e.g. McpDraftClinicalNoteController maps `/mcp/draft-clinical-notes`, reachable at
 * `/api/mcp/draft-clinical-notes`.
 */
import { fetchApi } from '../client';
import { buildQS } from '../helpers';
import type {
  McpDraftClinicalNote, McpAuditLog, McpAuditLogsPage, McpFeatureConfig,
} from '../../../types';

export const mcpDraftNotesModule = {
  listForPatient: (patientId: string) =>
    fetchApi<McpDraftClinicalNote[]>(
      `/api/mcp/draft-clinical-notes${buildQS({ patientId })}`
    ),
};

export const mcpAuditModule = {
  getLogs: (limit = 50, page = 0, clinicId?: string) =>
    fetchApi<McpAuditLog[] | McpAuditLogsPage>(
      `/api/mcp/audit-logs${buildQS({ limit, page, clinicId })}`
    ),
};

export const mcpSettingsModule = {
  get: () =>
    fetchApi<McpFeatureConfig>('/api/clinic/mcp-settings'),

  setWriteToolsEnabled: (enabled: boolean) =>
    fetchApi<McpFeatureConfig>('/api/clinic/mcp-settings/write-tools', {
      method: 'PUT',
      body: JSON.stringify({ enabled }),
    }),
};
